const invoicesFilters = [];

export default invoicesFilters;
